import type { FC } from "react";
import { useAgents } from "../../admin/agents/useAgents";
import { Select } from "../../components/select/Select";

interface Props {
  readonly agentId: string | null;
  readonly defaultAgentId?: string;
  readonly label?: string;
  readonly readonly?: boolean;
  readonly size?: "small" | "medium";
  readonly requirePhone?: boolean;
  readonly emptyOptionLabel?: string;
  readonly onChange: (agentId: string | null) => void;
}

const AgentSelect: FC<Props> = ({
  agentId,
  defaultAgentId,
  label,
  readonly,
  size,
  requirePhone,
  emptyOptionLabel,
  onChange,
}) => {
  const { agents } = useAgents();
  const selectableAgents = requirePhone ? agents?.filter((a) => a.contact.phone) : agents;
  const agentOptions =
    selectableAgents?.map((a) => ({
      value: a.id,
      label: defaultAgentId && a.id === defaultAgentId ? `${a.name} (domyślny)` : a.name,
    })) ?? [];
  return (
    <Select
      label={label ?? "Opiekun"}
      fullWidth
      size={size}
      value={agentId ?? ""}
      readonly={readonly}
      values={emptyOptionLabel !== undefined ? [{ value: "", label: emptyOptionLabel }, ...agentOptions] : agentOptions}
      onSelect={(agentId) => onChange(agentId || null)}
    />
  );
};

export default AgentSelect;
